import React, {Component} from 'react';
import TableFilter from '../TableFilter'
import GareTable from './GareTable'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import {createInstance} from '../../Helpers';
import PropTypes from 'prop-types';
import GareElenco from "../../pdf/GareElenco";
import GaraInCommessaComboFilter from "./GaraInCommessaComboFilter";
import GaraPartecipatoComboFilter from "./GaraPartecipatoComboFilter";
import StatoGaraComboFilter from "./StatoGaraComboFilter";
import Moment from 'moment';

class GareList extends Component {

    constructor(props) {
        super(props);
        this.rowperpage = client.getDefaultRowsPerPage();
        this.state = this.getDefaultState();

        this.storeInstance = createInstance();

        this.onChangePage = this.onChangePage.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onChangeFilterNote = this.onChangeFilterNote.bind(this)
        this.onChangeFilterAnno = this.onChangeFilterAnno.bind(this)
        this.onChangeFilterCodiceCompleto = this.onChangeFilterCodiceCompleto.bind(this)
        this.onChangeStatoInCommessaFilter = this.onChangeStatoInCommessaFilter.bind(this)
        this.onChangeStatoPartecipatoFilter = this.onChangeStatoPartecipatoFilter.bind(this)
        this.onChangeStatoGaraFilter = this.onChangeStatoGaraFilter.bind(this)
        this.onChangeColumnOrder = this.onChangeColumnOrder.bind(this)
        this.loadData = this.loadData.bind(this)
        this.pdfExport = this.pdfExport.bind(this)
        this.onDeleteGara = this.onDeleteGara.bind(this)
        this.onCreaCommessa = this.onCreaCommessa.bind(this)
        this.getStartPageByListViewType = this.getStartPageByListViewType.bind(this)
        this.getFilterDescription = this.getFilterDescription.bind(this)
        this.onResettaFiltri = this.onResettaFiltri.bind(this)

    }

    getDefaultState(){
        return {
            lastIdGara: -1,
            items: [],
            total: 0,
            page: 1,
            orderInfo: {
                columnName: 'nome',
                direction: 'A',
                //data: [{field: 'priorita', direction: 'A', },{field: 'nome', direction: 'A', }]},
                data: [{field: 'nome', direction: 'A', }]},
            filterInfo: {
                statoInCommessa: '0',
                statoInCommessaDesc: '',
                statoPartecipato: '0',
                statoPartecipatoDesc: '',
                statoGara: 'ALL',
                statoGaraDesc: 'Tutte le gare',
                keywordNote: '',
                keywordAnno: Moment().format("YYYY"),
                keywordCodiceCompleto: "",
                keyword: '',
            },
            _loading: false,
            error: null,
            listViewType: 'l',
        };
    }

    getFilterDescription() {
        let msg = '';
        if (this.state.filterInfo.keywordCodiceCompleto !== undefined && this.state.filterInfo.keywordCodiceCompleto !== ''){
            msg += ' Codice: ' + this.state.filterInfo.keywordCodiceCompleto + ' ';
        }
        if (this.state.filterInfo.keyword !== undefined && this.state.filterInfo.keyword !== ''){
            msg += 'Nome/codice/SID/IPA/CUP: ' + this.state.filterInfo.keyword;
        }
        if (this.state.filterInfo.keywordAnno !== undefined && this.state.filterInfo.keywordAnno !== ''){
            msg += ' Anno: ' + this.state.filterInfo.keywordAnno + ' ';
        }
        if (this.state.filterInfo.keywordNote !== undefined && this.state.filterInfo.keywordNote !== ''){
            msg += ' Note: ' + this.state.filterInfo.keywordNote + ' ';
        }
        if (this.state.filterInfo.statoGaraDesc !== undefined && this.state.filterInfo.statoGaraDesc !== ''){
            msg += ' Stato: ' + this.state.filterInfo.statoGaraDesc + ' ';
        }
        if (this.state.filterInfo.statoInCommessaDesc !== undefined && this.state.filterInfo.statoInCommessaDesc.trim() !== ''){
            msg += ' ' + this.state.filterInfo.statoInCommessaDesc + ' ';
        }
        if (this.state.filterInfo.statoPartecipatoDesc !== undefined && this.state.filterInfo.statoPartecipatoDesc.trim() !== ''){
            msg += ' ' + this.state.filterInfo.statoPartecipatoDesc + ' ';
        }
        return  msg.trim();
    }

    onResettaFiltri(){
        this.setState(
            this.getDefaultState(),
            () => {this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);;}
        );
    }

    componentDidMount() {
        if (this.storeInstance && this.storeInstance.restore('garelist', this, () => {
            // Stato reimpostato. Ricarica i dati
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        })) 
        {} else {
            this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
        }
    }
    //     if (this.instance && this.instance.restore('garelist', this , () => {
    //
    //             if (this.props.location.state && this.props.location.state.item && this.props.location.state.from)
    //             {
    //                 if (this.props.location.state.from.pathname.includes("gare/edit"))
    //                 {
    //                     let gara = this.props.location.state.item;
    //                     let items = this.state.items.map((cit) => {
    //                         if (cit.idGara === gara.idGara)
    //                         {
    //                             return gara;
    //                         }
    //                         return cit;
    //                     });
    //                     this.setState({items: items});
    //                 }
    //                 else if (this.props.location.state.from.pathname.includes("gare/new"))
    //                 {
    //                     let gara = this.props.location.state.item;
    //                     let items = [gara];
    //                     this.setState({items: items.concat(this.state.items)});
    //                 }
    //
    //             }
    //             else {
    //                 this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo);
    //             }
    //
    //         }) === null){
    //         this.loadData(this.state.page,  this.state.orderInfo, this.state.filterInfo);
    //     }
    // }

    componentWillUnmount() {
        if (this.storeInstance) {
            //this.state = {filterInfo: this.state.filterInfo};
            this.storeInstance.save('garelist', this.state);
        }
    }

    getStartPageByListViewType(){
        return this.state.listViewType === 'l' ? 1 : -1;
    }

    onChangePage(newpage) {
        this.loadData(newpage, this.state.orderInfo, this.state.filterInfo)
    }

    onChangeColumnOrder(columnName, direction, data) {
        let newOrderInfo = {
            columnName: columnName,
            direction: direction,
            data: data
        };
        this.loadData(this.getStartPageByListViewType(), newOrderInfo, this.state.filterInfo)
    }
    onChangeFilter(data){
        let newFilterInfo = this.state.filterInfo;
        newFilterInfo.keyword = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, newFilterInfo)
    }

    onChangeFilterCodiceCompleto(data){
        let newFilterInfo = this.state.filterInfo;
        newFilterInfo.keywordCodiceCompleto = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, newFilterInfo)
    }

    onChangeFilterAnno(data){
        let newFilterInfo = this.state.filterInfo;
        newFilterInfo.keywordAnno = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, newFilterInfo)
    }

    onChangeFilterNote(data){
        let newFilterInfo = this.state.filterInfo;
        newFilterInfo.keywordNote = data.keyword;
        this.loadData(this.getStartPageByListViewType(), this.state.orderInfo, newFilterInfo)
    }

    onChangeStatoInCommessaFilter(codice, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.statoInCommessa = codice;
        filterInfo.statoInCommessaDesc = nome;
        this.loadData(1, this.state.orderInfo, filterInfo);
    }

    onChangeStatoPartecipatoFilter(codice, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.statoPartecipato = codice;
        filterInfo.statoPartecipatoDesc = nome;
        this.loadData(1, this.state.orderInfo, filterInfo);
    }

    onChangeStatoGaraFilter(codice, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.statoGara = codice;
        filterInfo.statoGaraDesc = nome;
        this.loadData(1, this.state.orderInfo, filterInfo);
    }

    onCreaCommessa(idGara){

    }

    loadData(page, orderInfo, filterInfo) {
        this.setState({_loading: true});
        client.loadGareList(
            this.rowperpage,
            page,
            orderInfo.data,
            filterInfo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        lastIdGara: data._extras["id_gara"],
                        items: data.items,
                        total: data.total,
                        page: page,
                        orderInfo: orderInfo,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    });
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });

    }

    onDeleteGara(ev, gara){

        this.setState({_loading: true});
        client.deleteGara(gara).then((response) => {
            if (response.ok){
                this.setState({
                    _loading: false,
                    error: null
                });
                this.loadData(this.state.page, this.state.orderInfo, this.state.filterInfo)
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    pdfExport(tipo){
        this.setState({_loading: true});
        client.loadGareList(
            this.rowperpage,
            -1,
            this.state.orderInfo.data,
            this.state.filterInfo
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        _loading: false,
                        error: null,
                    }, () =>{
                        let ce = null;
                        if (tipo === "completo"){
                            ce = new GareElenco();
                            ce.setTitle("Elenco Gare/Offerte");
                            ce.setFileName("report-gare.pdf");
                        }
                        let fd = this.getFilterDescription();
                        ce.setFilterDescription(fd);
                        ce.createPdf(data.items);
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push('/login')
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }

        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }

        return (<div className="ui">
            <h3 className="ui top block attached header">
                <div className="ui three column grid">
                    <div className="column">
                        <div className="ui green label">{this.state.total}</div> Gare/Offerte soddisfano i filtri specificati
                    </div>
                    <div className="column">
                        <div className="ui ">
                            <button className="ui  button" onClick={() => this.onResettaFiltri()}>
                                <i className="delete icon"></i>Reimposta i filtri</button>
                        </div>
                    </div>
                    <div className="right aligned column">
                        <div className="ui ">

                        </div>
                    </div>
                </div>


            </h3>
            <div className="ui attached segment">
                <div className="ui two column stackable grid">
                    <div className="six wide column">
                        <TableFilter
                            showPopup={false}
                            value={this.state.filterInfo.keywordCodiceCompleto}
                            placeholder="Filtra per codice composto (AA_NNNN) anche parziale"
                            onChangeFilter={this.onChangeFilterCodiceCompleto} />
                    </div>
                    <div className="three wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.keywordAnno}
                            placeholder="Anno"
                            onChangeFilter={this.onChangeFilterAnno} />
                    </div>
                    <div className="seven wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.keyword}
                            placeholder="Filtra per nome, codice, SID/IPA o CUP"
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                </div>
                <div className="ui two column stackable grid">
                    <div className="five wide column">
                        <TableFilter
                            showPopup={true}
                            value={this.state.filterInfo.keywordNote}
                            placeholder="Note o parte di esse"
                            onChangeFilter={this.onChangeFilterNote} />
                    </div>
                    <div className="three wide column">
                        <StatoGaraComboFilter
                            statoGara={this.state.filterInfo.statoGara}
                            abilitato={true}
                            onChange={this.onChangeStatoGaraFilter}
                        />
                    </div>
                    <div className="four wide column">
                        <GaraInCommessaComboFilter
                            statoInCommessa={this.state.filterInfo.statoInCommessa}
                            abilitato={true}
                            onChange={this.onChangeStatoInCommessaFilter}
                        />
                    </div>
                    <div className="four wide column">
                        <GaraPartecipatoComboFilter
                            statoPartecipato={this.state.filterInfo.statoPartecipato}
                            abilitato={true}
                            onChange={this.onChangeStatoPartecipatoFilter}
                        />
                    </div>
                </div>

            </div>

            <GareTable
                items={this.state.items}
                count={this.state.total}
                page={this.state.page}
                lastIdGara={this.state.lastIdGara}
                rowperpage={this.rowperpage}
                tableOrderingField={this.state.orderInfo.columnName}
                tableOrderingDirection={this.state.orderInfo.direction}
                onChangePage={this.onChangePage}
                onChangeOrder={this.onChangeColumnOrder}
                onDeleteItem={this.onDeleteGara}
                filterDescription={this.getFilterDescription()}
                onExportPdf={this.pdfExport}
                onCreaCommessa={this.onCreaCommessa}
                readOnly={client.getCurrentUser().isrolegarew===false}
            />
            {loader}
        </div>)
    }
}

GareList.contextTypes = {
    router: PropTypes.object
}


export default GareList;




/** WEBPACK FOOTER **
 ** ./src/components/gare/GareList.js
 **/